<template>
	<div class="img-box">
		<img v-if="getOtherCoverList[item.announcementId]" :src="getOtherCoverList[item.announcementId]" alt="" />
		<img v-if="!getOtherCoverList[item.announcementId]" v-loadPDF :data-src="item.announcementLink" alt="" />
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useCurrentContext } from './context';

defineProps({
	item: {
		type: Object
	}
});

const context = useCurrentContext();
const getOtherCoverList = computed(() => context?.staticCoverList || {});
</script>

<style lang="less" scoped>
.img-box {
	width: 100%;
	height: 100%;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>
